<div class="contenedor-spinner">
    <mat-progress-spinner
      [color]="color"
      [mode]="mode"
      [value]="value"
      diameter="160">
  </mat-progress-spinner>
  <span class="texto-cargando">Un momento<br>por favor...</span>
  </div>